import { connect } from "react-redux";
import { GetDataHeaderTableReportHandleAction } from "../../PlanHandle/actions";
import { GetDataDashboard2Action, GetDataDashboard3Action, GetDataDashboard4Action, GetDataDashboard5Action, GetDataDashboard6Action, GetDataDashboardAction, GetDataPlanDashboardAction, GetDataPlanNextWeekDashboardAction, GetDataPlanTimeExtendtionDashboardAction } from "../actions";
import { DashboardComponent } from "../components";

const mapStateToProps = state => {
    return {
        ...state,
        DataDashboard: state.allDashboardReducer.mainALLReducer.dashboardReducer.DataDashboard,
        DataDashboard2: state.allDashboardReducer.mainALLReducer.dashboard2Reducer.DataDashboard2,
        DataDashboard3: state.allDashboardReducer.mainALLReducer.dashboard3Reducer.DataDashboard3,
        DataDashboard4: state.allDashboardReducer.mainALLReducer.dashboard4Reducer.DataDashboard4,
        DataDashboard5: state.allDashboardReducer.mainALLReducer.dashboard5Reducer.DataDashboard5,
        DataDashboard6: state.allDashboardReducer.mainALLReducer.dashboard6Reducer.DataDashboard6,
        DataPlan: state.allDashboardReducer.mainALLReducer.planDashboardReducer.DataPlan,
        DataNextWeek: state.allDashboardReducer.mainALLReducer.planDashboardNextWeekReducer.DataNextWeek,
        DataTimeExtend: state.allDashboardReducer.mainALLReducer.planDashboardTimeExtendtionReducer.DataTimeExtend,
        DataHeaderTableReport: state.allPlanHandleReducers.headerTableReportReducer.DataHeaderTableReport,
        isResult: state.allDashboardReducer.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataDashboard: (DataDashboard) => {
            dispatch(GetDataDashboardAction(DataDashboard));
        },
        GetDataDashboard2: (DataDashboard2) => {
            dispatch(GetDataDashboard2Action(DataDashboard2));
        },
        GetDataDashboard3: (DataDashboard3) => {
            dispatch(GetDataDashboard3Action(DataDashboard3));
        },
        GetDataDashboard4: (DataDashboard4) => {
            dispatch(GetDataDashboard4Action(DataDashboard4));
        },
        GetDataDashboard5: (DataDashboard5) => {
            dispatch(GetDataDashboard5Action(DataDashboard5));
        },
        GetDataDashboard6: (DataDashboard6) => {
            dispatch(GetDataDashboard6Action(DataDashboard6));
        },
        GetDataPlanDashboard: () => {
            dispatch(GetDataPlanDashboardAction());
        },
        GetDataPlanNextWeekDashboard: (DataNextWeek) => {
            dispatch(GetDataPlanNextWeekDashboardAction(DataNextWeek));
        },
        GetDataPlanTimeExtendDashboard: (DataTimeExtend) => {
            dispatch(GetDataPlanTimeExtendtionDashboardAction(DataTimeExtend));
        },
        GetDataHeaderTableReport: (ID) => {
            dispatch(GetDataHeaderTableReportHandleAction(ID));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);